/*
 * @Author: your name
 * @Date: 2022-11-02 16:32:23
 * @LastEditTime: 2023-06-28 16:10:54
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /ops-manager-frontend/src/pages/EnvManage/HostMonitor/DiskPartition/index.tsx
 */
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { reducerStates } from 'root/store/types';
import { useIntl } from 'react-intl';
import { disk } from 'root/store/disk/actions';
import { common } from 'root/store/actions';
import { Button, message, Spin, Tabs, Tooltip } from 'sup-ui';
import { getSameLvPath, judgeTotalSize } from 'root/utils/getUnallocatedBlock';

import ConfrimDiskBody from 'root/pages/DiskConfig/ConfirmDiskBody';
import Icon from 'root/components/Icon';
import SelectDisk from 'root/pages/DiskConfig/SelectDisk';
import CommonModal from 'root/components/CommonModal';
import failImg from 'root/assets/images/illustrator_partitionfailed@2x.png';
import doingImg from 'root/assets/images/illustrator_inpartition@2x.png';

import {
  getDiskConfigApi,
  getAvailabledDisksApi,
  postVgdeleteApi,
  postAddDiskApi,
  postDiskResizeApi,
  getPartitionStatusApi,
} from 'root/services/disk';
import CommonEmpty from 'root/components/CommonEmpty';
import ChangeDisk from 'root/pages/DiskConfig/ChangeDisk';
import messages from '../messages';
import { diskConfigType, SelectDiskListDataType } from 'root/pages/DiskConfig/diskTypes';

import styles from './index.less';

// 服务器状态集合 init 全新服务器  3.5  4.0  unknown 未知
const serverStatusAttr = ['init', '3.5', '4.0', 'unknown'];
const { TabPane } = Tabs;

const DiskPartition = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { confirmDiskData, record, acitveKey } = useSelector((state: reducerStates) => state.disk);
  const { singleNodeId, cluster, acitveKey: hostActiveKey } = useSelector((state: reducerStates) => state.envManage);
  const [visible, setVisible] = useState(false);
  const [submit, setSubmit] = useState(false);
  const [formatSubmit, setFormatSubmit] = useState(false);
  const [selectDiskKeys, setSelectDiskKeys] = useState<string[]>([]);
  const [selectDiskListData, setSelectDiskListData] = useState<SelectDiskListDataType[]>([]);
  const [status, setTatus] = useState('');
  const [partitionInfo, setPartitionInfo] = useState({
    status: 'FINISHED', // 分盘动作是否在running
    result: 'SUCCESS', // 分盘的状态成功与否
    err: '', // 失败原因
  }); // 磁盘分区状态
  let loopTimer: any = null;
  let getDataLoopTimer: any = null;

  // 获取可用磁盘配置数据并保存到store
  useEffect(() => {
    // 只有当前tab等于主机检测才调接口
    if (hostActiveKey === '2' && singleNodeId) {
      getData(0);
    }
    return () => {
      clearTimeout(loopTimer);
      clearTimeout(getDataLoopTimer);
    };
  }, [hostActiveKey, singleNodeId]);

  const getData = (size: number) => {
    getDiskConfigApi({ size, clientIds: [singleNodeId as string], cluster: Number(cluster) })
      .then((res) => {
        const { data: { diskConfigs = [], status, partition } = {} } = res;
        const newServerStatus = serverStatusAttr[status];
        // 更新服务器状态
        dispatch(
          common.serverStatus({
            serverStatus: newServerStatus,
          }),
        );
        mergeLvpath(diskConfigs);
        setTatus(newServerStatus);
        // 如果从config获取到当前处于正在分区中
        if (partition) {
          const { status, result, err } = partition;
          checkStatus({ status, result });
          setPartitionInfo({ status, result, err });
        }
      })
      .catch(() => {
        getDataLoopGetData();
      })
      .finally(() => {});
  };

  const checkStatus = (partionInfo: any) => {
    const { status } = partionInfo;
    // 如果正在分区中
    if (status === 'RUNNING') {
      getPartitionStatusApi({ clientIds: [singleNodeId as string] }).then((res) => {
        const { data: { config = [] } = {} } = res;
        mergeLvpath(config);
      });
      loopGetData();
    }
  };

  // 轮询获取分区状态
  const loopGetData = () => {
    loopTimer = setTimeout(() => {
      clearTimeout(loopTimer);
      getPartionInfo();
    }, 3000);
  };

  // 分区信息分区信息
  const getDataLoopGetData = () => {
    getDataLoopTimer = setTimeout(() => {
      clearTimeout(getDataLoopTimer);
      getData(0);
    }, 10 * 1000);
  };

  // 获取分区信息
  const getPartionInfo = () => {
    getPartitionStatusApi({ clientIds: [singleNodeId as string] }).then((res) => {
      const { status, result, err } = res.data;
      // 分区完成
      if (status === 'FINISHED') {
        clearTimeout(loopTimer);
        loopTimer = null;
        getData(0);
        if (result === 'SUCCESS') {
          // 显示正常的磁盘页面
          setPartitionInfo({ status, result, err: '' });
        } else {
          // 显示失败的磁盘页面
          setPartitionInfo({ status, result, err });
        }
        return;
      }
      // 正在分区中
      loopGetData();
    });
  };

  // 格式化分区
  const deletePartition = async () => {
    setFormatSubmit(true);
    const body = {
      vgPath: confirmDiskData[0]?.vgPath,
      delete: true,
      clientIds: [singleNodeId as string],
    };
    // 格式化分区成功后重新加载页面开始前几步操作
    postVgdeleteApi(body).then(() => {
      navigate('/guide');
      setFormatSubmit(false);
    });
  };

  // 获取磁盘数据
  useEffect(() => {
    if (visible) {
      getDiskData();
    }
  }, [visible]);

  // 获取可以用磁盘
  const getDiskData = () => {
    getAvailabledDisksApi({ clientIds: [singleNodeId as string] }).then((res) => {
      const { data = [] } = res;
      setSelectDiskListData(data);
    });
  };

  const addDiskEvent = () => {
    if (!selectDiskKeys.length) {
      message.warn(intl.formatMessage(messages.selectDisk));
      return;
    }
    setSubmit(true);
    const params = {
      diskPaths: selectDiskKeys,
      vgPath: record?.vgPath,
      clientIds: [singleNodeId as string],
    };

    postAddDiskApi(params)
      .then(() => {
        // 添加完磁盘以后不可以立即去调最新的config数据,磁盘增加是需要时间的
        setTimeout(() => {
          message.success(intl.formatMessage(messages.addDiskSuccess));
          close();
          setSubmit(false);
          dispatch(disk.filterRecord({ id: 0 }));
          getData(0);
        }, 5 * 1000);
      })
      .catch(() => {
        message.error(intl.formatMessage(messages.addDiskFiled));
        setSubmit(false);
        dispatch(disk.filterRecord({ id: 0 }));
      });
  };

  // 将lvpath相同的数据合并在一起
  const mergeLvpath = (data: diskConfigType[]) => {
    const tempData: diskConfigType[] = [];
    data.forEach((item) => {
      item.mountPoints = getSameLvPath(item.mountPoints, item.vgName);
      tempData.push(item);
    });
    dispatch(
      disk.getDiskData({
        confirmDiskData: tempData,
      }),
    );
  };

  // 关闭模态框
  const close = () => {
    setVisible(false);
    setSelectDiskKeys([]);
  };

  // 切换tab
  const changeActiveKey = (key: string) => {
    dispatch(disk.getDiskId({ acitveKey: key }));
  };

  // 扩展分区
  const updateSize = () => {
    if (judgeTotalSize(record as diskConfigType).result) {
      message.error(intl.formatMessage(messages.judgeTotalSize));
      return Promise.reject(new Error('2'));
    }

    const params: any = record?.mountPoints.map((ele: any) => ({
      lvPath: ele.lvPath,
      size: Number(ele.size),
    }));

    return postDiskResizeApi({
      resizeList: params,
      clientIds: [singleNodeId as string],
    }).then(() => {
      message.success(intl.formatMessage(messages.partitionSuccess));
      getData(0);
    });
  };

  const renderDiffCompoment = (status: string) => {
    switch (status) {
      case 'init':
        return (
          <div className={styles.init}>
            <CommonEmpty content={intl.formatMessage(messages.cannotFindDisk)} />
            <Button onClick={() => navigate('/guide')} type="primary">
              {intl.formatMessage(messages.addRightNow)}
            </Button>
          </div>
        );
      case '3.5':
      case '4.0':
        return confirmDiskData.map((item) => (
          <ConfrimDiskBody
            key={item.id}
            id={item.id}
            freeSize={item.freeSize}
            totalSize={item.totalSize}
            vgPath={item.vgPath}
            vgName={item.vgName}
            dataSource={item.mountPoints}
            columnLists={['mountPoint', 'size', 'usedSize', 'operate']}
            updataDiskSize={false}
            showPlus={true}
            setAddDiskVisible={setVisible}
          />
        ));
      case 'unknown':
        return (
          <Tabs activeKey={acitveKey} onChange={changeActiveKey} animated={false}>
            {confirmDiskData.map((item) => {
              return (
                <TabPane
                  tab={`${intl.formatMessage(messages.group)}${item.id}`}
                  key={`${item.id}`}
                  className={styles.unknown}
                >
                  <ConfrimDiskBody
                    id={item.id}
                    freeSize={item.freeSize}
                    totalSize={item.totalSize}
                    vgPath={item.vgPath}
                    vgName={item.vgName}
                    dataSource={item.mountPoints}
                    columnLists={['mountPoint', 'size', 'usedSize']}
                    updataDiskSize={false}
                    showPlus={false}
                    lessen={true}
                    setAddDiskVisible={setVisible}
                  />
                  <div className={styles.btns}>
                    {/* <div>{intl.formatMessage(messages.diskCannotUse)}</div> */}
                    <Button>{intl.formatMessage(messages.refersh)}</Button>
                    <Tooltip defaultVisibled={true} title={intl.formatMessage(messages.createTip)}>
                      &nbsp;
                      <Icon style={{ fontSize: 16 }} type="tip16" />
                      &nbsp;
                    </Tooltip>
                  </div>
                </TabPane>
              );
            })}
          </Tabs>
        );
      default:
        break;
    }
  };

  return (
    <div className={styles.diskPartition}>
      {renderDiffCompoment(status)}

      <div
        className={styles.diskStatus}
        style={{ display: partitionInfo?.status === 'RUNNING' || partitionInfo?.result === 'FAILED' ? 'flex' : 'none' }}
      >
        {partitionInfo?.status === 'RUNNING' && (
          <div className={styles.doing}>
            <img src={doingImg} />
            <h6>{intl.formatMessage(messages.createDisking)}</h6>
          </div>
        )}
        {partitionInfo?.result === 'FAILED' && (
          <div className={styles.fail}>
            <img src={failImg} />
            <h6>{intl.formatMessage(messages.createDiskFail)}</h6>
            <div className={styles.error}>{partitionInfo?.err}</div>
            <Button disabled={formatSubmit} onClick={deletePartition} type="primary">
              {intl.formatMessage(messages.createDiskAgain)}
            </Button>
          </div>
        )}
      </div>

      <CommonModal
        title={
          <div>
            {intl.formatMessage(messages.selsectAddDisk)}
            <span className={styles.confirmSubTitle}>({intl.formatMessage(messages.multipleChoices)})</span>
          </div>
        }
        height="auto"
        visible={visible}
        onCancel={close}
        className={styles.addDiskModal}
        footer={[
          selectDiskListData.length > 0 && (
            <div key="tip" className={styles.addDiskTip}>
              <Icon style={{ fontSize: 20 }} type="tixing40" />
              <span className={styles.word}>{intl.formatMessage(messages.addDiskOperationTip)}</span>
            </div>
          ),
          <Button disabled={submit} type="primary" key="add" onClick={addDiskEvent}>
            {intl.formatMessage(selectDiskListData.length ? messages.add : messages.sure)}
          </Button>,
          <Button disabled={submit} onClick={close} key="cancel">
            {intl.formatMessage(messages.cancel)}
          </Button>,
        ]}
      >
        {selectDiskListData.length ? (
          <Spin tip={intl.formatMessage(messages.doing)} spinning={submit}>
            <SelectDisk
              diskListData={selectDiskListData}
              selectDiskKeys={selectDiskKeys}
              setSelectDiskKeys={setSelectDiskKeys}
            />
          </Spin>
        ) : (
          <CommonEmpty content={intl.formatMessage(messages.cannotFindDisk)} />
        )}
      </CommonModal>

      <ChangeDisk
        // 分区之前允许缩小,除此之外都不允许缩小
        lessen={status === 'init' ? true : false}
        onOk={updateSize}
        type={status === 'init' ? 'danger' : 'primary'}
        okText={intl.formatMessage(status === 'init' ? messages.resetSize : messages.extension)}
      />
    </div>
  );
};
export default DiskPartition;
